import React from "react";
import { Text, Input, Divider, Group } from '@mantine/core';

const BarangKelengkapanDibatalkan = ({ stateData }) => {

    return (
        <React.Fragment>
            <Input.Wrapper
                id={stateData.data.id}
                withAsterisk={stateData.data.withAsterisk}
                styles={(tema) => ({
                    label: {
                        width: '100%'
                    }
                })}
                label={stateData.data.label}
                description={stateData.data.description}
            >
                {Array.isArray(stateData.data.value) && (stateData.data.value.length > 0) ?
                    Object.keys(stateData.data.value).map((key, index) => {
                        return (
                            <React.Fragment
                                key={key}
                            >
                                <Group
                                    position="apart"
                                    noWrap
                                    align='flex-start'
                                    mt='xs'
                                    mb={stateData.data.value.length === (Number(index) + 1) ? '0' : 'sm'}
                                >
                                    <Group
                                        noWrap
                                        align="flex-start"
                                        spacing={5}
                                    >
                                        <Text size='sm'>
                                            {Number(index) + 1}.
                                        </Text>

                                        <Text size='sm'>
                                            {stateData.data.value[key].kelengkapan_barang_nama}
                                        </Text>
                                    </Group>
                                </Group>

                                {(Number(index) + 1) !== stateData.data.value.length && <Divider />}
                            </React.Fragment>
                        )
                    })
                    :
                    <Text
                        size='sm'
                        color="dimmed"
                    >
                        Tidak ada data.
                    </Text>
                }
            </Input.Wrapper>
        </React.Fragment>
    )
}

export default BarangKelengkapanDibatalkan;